// Centralized API base configuration for frontend
// Works for both localhost (dev) and GCP Cloud Run (prod)
const isProd = process.env.NODE_ENV === 'production';

const resolveEnv = (value: string | undefined, fallback: string): string => {
  if (value && value.trim()) return value.trim();
  return fallback;
};

export const API_BASE = resolveEnv(
  process.env.REACT_APP_API_URL,
  isProd ? window.location.origin : 'http://localhost:8000'
);

// In production (GCP Cloud Run), ADK and MCP are proxied through the
// main API gateway, so they default to API_BASE when not explicitly set.
export const ADK_BASE = resolveEnv(
  process.env.REACT_APP_ADK_URL,
  isProd ? API_BASE : 'http://localhost:8001'
);

export const MCP_BASE = resolveEnv(
  process.env.REACT_APP_MCP_URL,
  isProd ? `${API_BASE}/mcp-server/mcp` : 'http://localhost:9000/mcp-server/mcp'
);

export const apiUrl = (path: string) => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
};

export const adkUrl = (path: string) => {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${ADK_BASE}${p}`;
};

export const mcpUrl = (path: string) => {
  if (!path) {
    return MCP_BASE;
  }
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${MCP_BASE}${p}`;
};
